import styled from 'styled-components';
import Image from '../../Media/Image/Image';
import Breakpoints from '../../utils/breakpoints';
export const StyledProductTile = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledProductTile",
  componentId: "sc-t15ukr-0"
})(["position:relative;margin-bottom:16px;font-family:'Roboto',Helvetica,Arial,sans-serif;background-color:white;&:hover{box-shadow:0px 1px 7px 0px #00000080;}svg{opacity:1 !important;cursor:auto !important;}"]);
export const StyledProductTileInner = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledProductTileInner",
  componentId: "sc-t15ukr-1"
})(["display:flex;flex-direction:column;justify-content:space-between;min-height:180px;@media (min-width:768px){width:100%;flex-direction:row;}"]);
export const StyledProductImage = styled(Image).withConfig({
  displayName: "HorizontalProductCardstyled__StyledProductImage",
  componentId: "sc-t15ukr-2"
})(["margin-right:20px;"]);
export const StyledProductContent = styled.a.withConfig({
  displayName: "HorizontalProductCardstyled__StyledProductContent",
  componentId: "sc-t15ukr-3"
})(["display:flex;align-items:center;padding:34px 12px 24px 12px;font-family:'Roboto',Helvetica,Arial,sans-serif;@media (min-width:", "){padding:24px 12px;}"], Breakpoints.md);
export const StyledProductContentInner = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledProductContentInner",
  componentId: "sc-t15ukr-4"
})(["width:100%;margin-top:12px;margin-bottom:12px;h3{margin-bottom:16px;font-size:1rem;font-weight:700;line-height:1.5;color:#000;}span svg{width:16px !important;height:16px !important;vertical-align:middle;}"]);
export const StyledInfoContainer = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledInfoContainer",
  componentId: "sc-t15ukr-5"
})(["display:flex;flex-direction:column;@media (min-width:768px){flex-direction:row;}@media (min-width:800px) and (max-width:900px){flex-direction:column;}"]);
export const StyledAttributes = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledAttributes",
  componentId: "sc-t15ukr-6"
})(["line-height:1.5;color:#736b6b;@media (min-width:768px){margin-right:16px;}"]);
export const StyledDescription = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledDescription",
  componentId: "sc-t15ukr-7"
})(["display:none;color:black;@media (min-width:768px){display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;max-height:48px;overflow:hidden;margin-right:16px;margin-top:16px;}"]);
export const StyledProductPurchaseInfo = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledProductPurchaseInfo",
  componentId: "sc-t15ukr-8"
})(["margin:0 12px 24px;@media (min-width:768px){display:flex;margin:24px 12px;flex-direction:column;justify-content:center;align-items:center;min-width:176px;}"]);
export const StyledPriceContainer = styled.div.withConfig({
  displayName: "HorizontalProductCardstyled__StyledPriceContainer",
  componentId: "sc-t15ukr-9"
})(["display:flex;margin-bottom:8px;flex-direction:row;justify-content:center;align-items:center;"]);
export const StyledByoButton = styled.a.withConfig({
  displayName: "HorizontalProductCardstyled__StyledByoButton",
  componentId: "sc-t15ukr-10"
})(["margin-top:8px;"]);
export const StyledTryASample = styled.a.withConfig({
  displayName: "HorizontalProductCardstyled__StyledTryASample",
  componentId: "sc-t15ukr-11"
})(["display:flex;align-items:center;margin-top:8px;font-size:0.875rem;line-height:1.5;height:48px;justify-content:center;color:black;&:hover{color:black;}"]);